<template>
  <div class="AdvicesSwiper">
    <swiper :options="swiperOption" ref="mySwiper" class="AdvicesSwiper_swiper">
      <swiper-slide class="AdvicesSwiper_slide" v-for="(slide, index) in data" :key="index" @click.native="$emit('openPanel', { type: 'advice', slug: slide.slug })">
        <Advice :data="slide" />
      </swiper-slide>

    </swiper>
  </div>
</template>

<script>
  import Advice from "@/components/Advice"

  export default {
    name: "AdvicesSwiper",
    props: [ 'data' ],
    components: { Advice },
    data() {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          centeredSlides: true,
          grabCursor: true,
          spaceBetween: 10
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted()
    {
      this.$nextTick( () => {
        if(!this.$tools.isMobile())
          this.swiper.slideTo(1, 0, false)
      })
    }
  }
</script>

<style lang="stylus">
.AdvicesSwiper

  position relative
  width 100%
  margin auto
  margin-top 30px
  
  .swiper-container

    overflow visible

  .swiper-wrapper

    align-items stretch  

  &_slide

    position relative
    width 100%
    height auto!important
    min-height 255px
    max-width 385px

    @media $medium
      
      min-height auto

    @media $small

      max-width 325px
      width 70%
</style>